import { Grid } from "@mui/material";
import EditProfileDetails from "../../components/UI/Forms/Wizard Forms/EditForms/EditProfileDetails";
//import Activity from "../UserInfo/Activity/Activity";

const EditProfile = () => {
  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <EditProfileDetails />
        </Grid>
        {/* <Grid item xs={8}>
          <Activity />
        </Grid> */}
      </Grid>
    </div>
  );
};

export default EditProfile;
